export const ROUTES = {
  HOME: "/",
  DETAIL: "/detail/:id",
  FAVORITES: "/favorites",
};
